import React from 'react';
import Avatar from '@mui/material/Avatar';
import { getStudentPhotoUrl } from '../utils/studentPhoto';

export default function StudentAvatar({ student, children, ...props }) {
  const name = student?.user?.name || student?.name || student?.studentName || 'Student';
  const initials = name.trim().split(/\s+/).map(part => part[0]).slice(0, 2).join('').toUpperCase();

  return (
    <Avatar {...props} alt={name} src={getStudentPhotoUrl(student)}>
      {children || initials}
    </Avatar>
  );
}
